module.exports = __webpack_public_path__ + "_/node_modules/leaflet/dist/images/marker-icon-2x.png?ver=401d815d";